/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMapPinCancel = createReactComponent("map-pin-cancel", "IconMapPinCancel", [
  ["path", { d: "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", key: "svg-0" }],
  [
    "path",
    {
      d: "M12.463 21.431a1.999 1.999 0 0 1 -1.876 -.531l-4.244 -4.243a8 8 0 1 1 13.594 -4.655",
      key: "svg-1"
    }
  ],
  ["path", { d: "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-2" }],
  ["path", { d: "M17 21l4 -4", key: "svg-3" }]
]);

export { IconMapPinCancel as default };
//# sourceMappingURL=IconMapPinCancel.js.map
